import { observable } from 'mobx';
import type { ConnectedCalendarResponseArgs } from './connected_calendar';
import ConnectedCalendar, { convertConnectedCalendarResponseToArgs } from './connected_calendar';

export type OrderItemCalendarEventResponseArgs = {
  id: number;
  trace_id: number;
  order_item_id: number;
  user_id: number;
  connected_calendar_provider: number;
  connected_calendar_email: string;
  connected_calendar?: ConnectedCalendarResponseArgs; // オプショナルにする（動的取得のため）
  event_id: number;
  html_link: string;
  element_id?: number;
  element_type?: string;
};

export type OrderItemCalendarEventArgs = {
  id: number;
  traceId: number;
  orderItemId: number;
  userId: number;
  connectedCalendarProvider: number;
  connectedCalendarEmail: string;
  connectedCalendar?: ConnectedCalendar; // オプショナルにする
  eventId: number;
  htmlLink: string;
  elementId?: number;
  elementType?: string;
};

export const convertOrderItemCalendarEventResponseToArgs = (response: OrderItemCalendarEventResponseArgs) => {
  const args: OrderItemCalendarEventArgs = {
    id: response.id,
    traceId: response.trace_id,
    orderItemId: response.order_item_id,
    userId: response.user_id,
    connectedCalendarProvider: response.connected_calendar_provider,
    connectedCalendarEmail: response.connected_calendar_email,
    connectedCalendar: response.connected_calendar
      ? new ConnectedCalendar(convertConnectedCalendarResponseToArgs(response.connected_calendar))
      : undefined,
    eventId: response.event_id,
    htmlLink: response.html_link,
    elementId: response.element_id,
    elementType: response.element_type
  };
  return args;
};

export default class OrderItemCalendarEvent {
  @observable id: number;

  @observable traceId: number;

  @observable orderItemId: number;

  @observable userId: number;

  @observable connectedCalendarProvider: number;

  @observable connectedCalendarEmail: string;

  @observable connectedCalendar?: ConnectedCalendar;

  @observable eventId: number;

  @observable htmlLink: string;

  @observable elementId?: number;

  @observable elementType?: string;

  constructor(args: OrderItemCalendarEventArgs) {
    this.id = args.id;
    this.traceId = args.traceId;
    this.orderItemId = args.orderItemId;
    this.userId = args.userId;
    this.connectedCalendarProvider = args.connectedCalendarProvider;
    this.connectedCalendarEmail = args.connectedCalendarEmail;
    this.connectedCalendar = args.connectedCalendar;
    this.eventId = args.eventId;
    this.htmlLink = args.htmlLink;
    this.elementId = args.elementId;
    this.elementType = args.elementType;
  }
}
